// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Mf8KR","label":"Completed_label__GFNXA"};